import { render, staticRenderFns } from "./WalletTransactionDetailTemplate.vue?vue&type=template&id=51b2eb08"
import script from "./WalletTransactionDetailTemplate.vue?vue&type=script&lang=js"
export * from "./WalletTransactionDetailTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports